import { CSSProperties, ReactNode } from 'react';
import { Transition } from 'react-transition-group';

const SlideDownAnimationHOC = ({ show, children, startDelay = 0 }: { show: boolean, children: ReactNode, startDelay?: number}) => {
  const duration = 850;
  const timeOutStartDelay = show === false ? 0 : startDelay

  const defaultStyle = (startDelay = 0) => {
    const css: CSSProperties = {
      transition: `opacity ${duration}ms cubic-bezier(.2,.16,.52,.99) ${startDelay}ms, transform ${duration}ms cubic-bezier(.2,.16,.52,.99) ${startDelay}ms`,
      opacity: 0,
      transform: `translateY(-30px)`,
    }
    return css
  }

  const transitionStyles = () => {
    const css: Record<string, CSSProperties> = {
      entering: { opacity: 1, transform: 'translateY(0px)' },
      entered:  { opacity: 1, transform: 'translateY(0px)' },
      exiting:  { opacity: 0, transform: `translateY(30px)` },
      exited:  { opacity: 0, transform: `translateY(-30px)` },
    }
    return css
  }

  return (
    <Transition in={show} timeout={timeOutStartDelay + duration}>
      {state => {
        const delay = (state === "exiting" || state === "exited") ? 0 : startDelay
        return (
          <div style={{
            ...defaultStyle(delay),
            ...transitionStyles()[state]
          }}>
            {children}
          </div>
        )
      }}
    </Transition>
  )
}

export default SlideDownAnimationHOC;

export const FadeInAnimationHOC = ({ show, children }: { show: boolean, children: ReactNode}) => {
  const duration = 300;

  const defaultStyle = {
    transition: `opacity ${duration}ms ease`,
    opacity: 0,
  }

  const transitionStyles: Record<string, CSSProperties> = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
  };

  return (
    <Transition in={show} timeout={duration}>
      {(state) => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  )
}